import React, { useCallback, useContext, useReducer } from "react";
import { Commands } from 'shared/resources/BitbiteCommands';
import { SessionContext } from 'shared/system-controls/session/SessionProvider';
import ProductReducer from './ProductReducer';

export const ProductContext = React.createContext();

//----------------------------
const ProductState = ({ children }) => {
    const initialState = {
    };
    const [state, dispatch] = useReducer(ProductReducer, initialState);
    const { asyncServiceCall } = useContext(SessionContext);

    //--------------------------------------------------------
    const getProductsCount = useCallback(async () => {
        try {
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_ORDER_LIST_COUNT_GET);
            dispatch({ type: 'SET_STATE_DATA', payload: res });
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getProducts = useCallback(async ({ filters }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_PRODUCT_LIST_GET, { filters });
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });

        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getMenus = useCallback(async ({ searchStr }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_LIST_GET, { searchStr });
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });

        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getContents = useCallback(async ({ searchStr }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_CONTENT_LIST_GET, { searchStr });
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });

        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getContainers = useCallback(async ({ searchStr }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_CONTAINER_LIST_GET, { searchStr });
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });

        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getMenu = useCallback(async ({ menuID }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_GET(menuID), {});
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });

        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getContent = useCallback(async ({ contentID }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_CONTENT_GET(contentID), {});
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getContainer = useCallback(async ({ containerID }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_CONTAINER_GET(containerID), {});
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const getProduct = useCallback(async ({ productID }) => {
        try {
            dispatch({ type: 'LOADING' });
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_PRODUCT_GET(productID), {});
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            dispatch({ type: 'LOADED' });
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const saveMenu = useCallback(async ({ menu, menuID, callback }) => {
        try {
            await asyncServiceCall(menuID
                ? Commands.API_URL_BITBITE_BO_MENU_SET(menuID)
                : Commands.API_URL_BITBITE_BO_MENU_NEW
                , { menu });
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const copyMenu = useCallback(async ({ menuID, callback }) => {
        try {
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_GET(menuID), {});
            let menu = res.menu;
            delete menu._id;
            res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_NEW, { menu });
            callback && callback(res.menu?._id);
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const saveMenuGeneralInfo = useCallback(async ({ menu, menuID, callback }) => {
        const { title, desc } = menu || {}
        try {
            if (!title || !desc) {
                dispatch({ type: 'SET_STATE_DATA', payload: { requireCheck: true } });
                return;
            }
            const res = await asyncServiceCall(menuID
                ? Commands.API_URL_BITBITE_BO_MENU_SET(menuID)
                : Commands.API_URL_BITBITE_BO_MENU_NEW
                , { menu: { title, desc } });
            callback && callback(res.menu);
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const setMenuSection = useCallback(async ({ menu, menuID, sectionID, callback }) => {
        try {
            await asyncServiceCall(sectionID
                ? Commands.API_URL_BITBITE_BO_MENU_SECTION_SET(menuID, sectionID)
                : Commands.API_URL_BITBITE_BO_MENU_SECTION_NEW(menuID)
                , { menu });
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const removeMenuProductType = useCallback(async ({ menuID, sectionID, productTypeID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_PRODUCT_DELETE(menuID, sectionID, productTypeID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const removeMenuSection = useCallback(async ({ menuID, sectionID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_SECTION_DELETE(menuID, sectionID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const orderUpMenuSection = useCallback(async ({ menuID, sectionID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_SECTION_ORDER_UP(menuID, sectionID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const orderDownMenuSection = useCallback(async ({ menuID, sectionID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_SECTION_ORDER_DOWN(menuID, sectionID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const orderUpMenuProductType = useCallback(async ({ menuID, sectionID, typeID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_PRODUCT_TYPE_ORDER_UP(menuID, sectionID, typeID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const orderDownMenuProductType = useCallback(async ({ menuID, sectionID, typeID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_MENU_PRODUCT_TYPE_ORDER_DOWN(menuID, sectionID, typeID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const saveContent = useCallback(async ({ content, contentID, callback }) => {
        try {
            await asyncServiceCall(contentID && contentID !== '0'
                ? Commands.API_URL_BITBITE_BO_CONTENT_SET(contentID)
                : Commands.API_URL_BITBITE_BO_CONTENT_NEW
                , { content });
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const saveContainer = useCallback(async ({ container, containerID, callback }) => {
        try {
            await asyncServiceCall(containerID && containerID !== '0'
                ? Commands.API_URL_BITBITE_BO_CONTAINER_SET(containerID)
                : Commands.API_URL_BITBITE_BO_CONTAINER_NEW
                , { container });
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const saveProduct = useCallback(async ({ product, productID, callback }) => {
        try {
            product.noBusinessDiscountAllowed = product.noBusinessDiscountAllowed === true ||
                product.noBusinessDiscountAllowed === 'BUSINESS_DISCOUNT_NOT_ALLOWED' ? true : false;
            await asyncServiceCall(productID && productID !== '0'
                ? Commands.API_URL_BITBITE_BO_PRODUCT_SET(productID)
                : Commands.API_URL_BITBITE_BO_PRODUCT_NEW
                , { product });
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const setMenuDefault = useCallback(async ({ menuID, callback }) => {
        try {
            await asyncServiceCall(Commands.API_URL_BITBITE_BO_DEFAULT_MENU_SET(menuID));
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    //--------------------------------------------------------
    const orderPacked = useCallback(async ({ order, callback }) => {
        try {
            let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_ORDER_PACKED(order?._id));
            dispatch({ type: 'SET_STATE_DATA', payload: res });
            callback && callback();
        }
        catch (err) {
            dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
        }
    }, [dispatch, asyncServiceCall]);

    return (
        <ProductContext.Provider
            value={{
                state,
                ...state,
                dispatch,
                getProductsCount,
                orderPacked,
                saveMenu,
                saveMenuGeneralInfo,
                setMenuSection,
                removeMenuProductType,
                removeMenuSection,
                getMenus,
                getMenu,
                setMenuDefault,
                getContents,
                saveContent,
                getContent,
                getContainer,
                getContainers,
                saveContainer,
                getProducts,
                getProduct,
                saveProduct,
                orderUpMenuSection,
                orderDownMenuSection,
                copyMenu,
                orderUpMenuProductType,
                orderDownMenuProductType,
            }}
        >
            {children}
        </ProductContext.Provider>
    )
}

export default ProductState;
